import { Link } from "react-router-dom";

interface FeedSidebarProps {
  isAuthenticated: boolean;
}

export function FeedSidebar({ isAuthenticated }: FeedSidebarProps) {
  return (
    <div className="space-y-3">
      {/* About Squids */}
      <div className="panel">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-xl bg-brand flex items-center justify-center">
            <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M8 12c0-2.21 1.79-4 4-4s4 1.79 4 4" />
              <path d="M8 16c0 .55.45 1 1 1h6c.55 0 1-.45 1-1" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-bold text-foreground">Squids</p>
            <p className="text-xs text-text-subtle">Where ideas surface</p>
          </div>
        </div>
        <p className="text-xs text-text-muted leading-relaxed mb-3">
          A next-generation Q&amp;A and social discussion platform. Discover ideas, ask questions, and engage with communities that matter.
        </p>
        {!isAuthenticated && (
          <div className="space-y-2">
            <Link to="/auth/register" className="btn-primary btn-sm w-full">
              Create account
            </Link>
            <Link to="/auth/login" className="btn-secondary btn-sm w-full">
              Sign in
            </Link>
          </div>
        )}
        {isAuthenticated && (
          <Link to="/post/create" className="btn-primary btn-sm w-full">
            Create a post
          </Link>
        )}
      </div>

      {/* Footer links */}
      <div className="px-1">
        <div className="flex flex-wrap gap-x-2 gap-y-1">
          {[
            { label: "Help", href: "/help" },
            { label: "About", href: "/about" },
            { label: "Careers", href: "/careers" },
            { label: "Privacy", href: `${import.meta.env.VITE_POLICIES_URL || "https://policies.squids.co.za"}/privacy` },
            { label: "Terms", href: `${import.meta.env.VITE_POLICIES_URL || "https://policies.squids.co.za"}/terms` },
            { label: "Rules", href: "/rules" },
          ].map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-xs text-text-subtle hover:text-text-muted transition-colors"
              target={link.href.startsWith("http") ? "_blank" : undefined}
              rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
            >
              {link.label}
            </a>
          ))}
        </div>
        <p className="text-xs text-text-subtle mt-2">
          &copy; {new Date().getFullYear()} Squids. All rights reserved.
        </p>
      </div>
    </div>
  );
}
